/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const propertyTypeJSON = async (): Promise<any> => {
  const propertyType = useJSONStore.getState().propertyType;
  const token = useUserStore.getState().userToken;
  const setPropertyType = useJSONStore.getState().setPropertyType;

  if (propertyType.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.propertyType}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setPropertyType(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default propertyTypeJSON;
